/**
 * Send
 * Communicate an action to a store. This is how Microcosm determines
 * how transaction parameters should update state.
 */

'use strict';

exports.__esModule = true;
exports['default'] = send;

var _typeChecks = require('./type-checks');

var _update = require('./update');

function send(key, store, state, type, payload) {
  var handler = store[type];

  if (handler === undefined && store.register) {
    handler = store.register()[type];
  }

  return _typeChecks.isFunction(handler) ? handler.call(store, _update.get(state, key), payload, state) : handler;
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zZW5kLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztxQkFTd0IsSUFBSTs7MEJBSEQsZUFBZTs7c0JBQ3RCLFVBQVU7O0FBRWYsU0FBUyxJQUFJLENBQUUsR0FBRyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRTtBQUM5RCxNQUFJLE9BQU8sR0FBRyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUE7O0FBRXpCLE1BQUksT0FBTyxLQUFLLFNBQVMsSUFBSSxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQzNDLFdBQU8sR0FBRyxLQUFLLENBQUMsUUFBUSxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUE7R0FDakM7O0FBRUQsU0FBTyx1QkFBVyxPQUFPLENBQUMsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxZQUFJLEtBQUssRUFBRSxHQUFHLENBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxDQUFDLEdBQUcsT0FBTyxDQUFBO0NBQzVGIiwiZmlsZSI6InNyYy9zZW5kLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBTZW5kXG4gKiBDb21tdW5pY2F0ZSBhbiBhY3Rpb24gdG8gYSBzdG9yZS4gVGhpcyBpcyBob3cgTWljcm9jb3NtIGRldGVybWluZXNcbiAqIGhvdyB0cmFuc2FjdGlvbiBwYXJhbWV0ZXJzIHNob3VsZCB1cGRhdGUgc3RhdGUuXG4gKi9cblxuaW1wb3J0IHsgaXNGdW5jdGlvbiB9IGZyb20gJy4vdHlwZS1jaGVja3MnXG5pbXBvcnQgeyBnZXQgfSBmcm9tICcuL3VwZGF0ZSdcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZCAoa2V5LCBzdG9yZSwgc3RhdGUsIHR5cGUsIHBheWxvYWQpIHtcbiAgbGV0IGhhbmRsZXIgPSBzdG9yZVt0eXBlXVxuXG4gIGlmIChoYW5kbGVyID09PSB1bmRlZmluZWQgJiYgc3RvcmUucmVnaXN0ZXIpIHtcbiAgICBoYW5kbGVyID0gc3RvcmUucmVnaXN0ZXIoKVt0eXBlXVxuICB9XG5cbiAgcmV0dXJuIGlzRnVuY3Rpb24oaGFuZGxlcikgPyBoYW5kbGVyLmNhbGwoc3RvcmUsIGdldChzdGF0ZSwga2V5KSwgcGF5bG9hZCwgc3RhdGUpIDogaGFuZGxlclxufVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/send.js
 ** module id = 202
 ** module chunks = 0
 **/